import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { UtilityText, StackLayout } from '@leagueplatform/genesis-core';
import { CopyButton } from '@web-config-app/core-react-ui';
import type { ParentId } from '@web-config-app/core';

export interface DataPointCopyItemProps {
  id: ParentId;
  label: string;
}

/**
 * Renders a data point item in copy mode, displaying the label and ID
 * with a copy button to copy the data point ID to clipboard.
 */
export const DataPointCopyItem: React.FC<DataPointCopyItemProps> = ({
  id,
  label,
}) => {
  const { formatMessage } = useIntl();
  return (
    <StackLayout
      orientation="horizontal"
      verticalAlignment="center"
      css={{ paddingY: '$quarter' }}
    >
      <StackLayout orientation="vertical" spacing="$quarter">
        <UtilityText>{label}</UtilityText>
        <UtilityText emphasis="subtle" size="sm">
          {id}
        </UtilityText>
      </StackLayout>
      {id && (
        <CopyButton
          label={formatMessage({ id: 'COPY_DATA_POINT_ID' }, { label })}
          priority="tertiary"
          contents={id}
          hideLabel
        />
      )}
    </StackLayout>
  );
};
